import React, { Component } from 'react'
import styled from 'styled-components'
import { Button as OriginalButton, Colors, Modal } from 'advenio-components'
import { connect } from 'react-redux'

import LoadingSpinner from '../LoadingSpinner'
import CreditCard from '../CreditCard'
import ProfileHeader from '../ProfileHeader'
import CreateCardModal from './CreateCardModal'
// import CreateCardModalPayU from './CreateCardModalPayU'
import { CONEKTA_PUBLIC_ADV_KEY,CONEKTA_PUBLIC_EAM_KEY, SR_PAGO_PUBLIC_KEY, PAYU_PUBLIC_KEY} from '../../config'

import AuthorizeModal from './AuthorizeModal'
import ActivateCardModal from './ActivateCardModal'

import { Selectors } from '../../Data/Redux/CountriesRedux'

import CardActions from '../../Data/Redux/CardsRedux'
import { notificationFail } from '../../Data/Redux/NotificationActions'

const Warning = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  width: 100%;
  font-size: 24px;
  color: ${Colors.gray600};

  @media (max-width:763px) {
    height: 80%;
    padding: 24px;
    text-align: center;
    font-size: 20px;
  }
`

const getModalToRender = (
  provider,
  { open, onClose, parent, sendCard, loading, errorAfterCreate, cards },
) =>
  ({
    Conekta: (
      <CreateCardModal
        provider={provider}
        open={open}
        onClose={onClose}
        parent={parent}
        sendCard={sendCard}
        loading={loading}
        errorAfterCreate={errorAfterCreate}
        forceDefault={cards.authorized && cards.authorized.length === 0}
      />
    ),
    // PayU: (
    //   <CreateCardModalPayU
    //     provider={provider}
    //     open={open}
    //     onClose={onClose}
    //     parent={parent}
    //     sendCard={sendCard}
    //     loading={loading}
    //     errorAfterCreate={errorAfterCreate}
    //     forceDefault={cards.authorized && cards.authorized.length === 0}
    //   />
    // ),
    // SrPago: (
    //   <CreateCardModal
    //     provider={provider}
    //     open={open}
    //     onClose={onClose}
    //     parent={parent}
    //     sendCard={sendCard}
    //     loading={loading}
    //     errorAfterCreate={errorAfterCreate}
    //     forceDefault={cards.authorized && cards.authorized.length === 0}
    //   />
    // ),
  }[provider])

const Header = styled.h2`
  margin: 16px;
  font-size: 16px;

  @media (max-width: 1200px) {
    margin-right: 8px;
  }
`
const PageContainer = styled.div`
  display: flex;
  min-height: 80vh;
`
const ParentContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 8px 0;
  background: ${Colors.blue100};
`
const CardListContainer = styled.div`
  display: flex;
  flex: 2;
  flex-direction: column;
  align-items: center;
`
const CardList = styled.div`
  width: 100%;
`
const ParentListHeader = styled.div`
  margin-top: 8px;
  padding: 8px;
  text-transform: uppercase;
  font-size: 12px;
  color: ${Colors.gray500};
`
const ParentList = styled.ul`
  list-style-type: none;
  padding: 0;
`
const ParentListItem = styled.li`
  padding: 8px;
  font-size: 14px;
  cursor: pointer;
  color: ${props => props.active ? Colors.blue500 : ''};
  background-color: ${props => props.active ? Colors.gray300 : ''};

  &:hover {
    background-color: ${Colors.gray300};
    color: ${Colors.blue500};
  }
`
const Button = styled(OriginalButton)`
  height: 42px;
  margin-right: 16px;
  padding: 8px 16px;
  font-size: 12px;

  @media (max-width: 1300px) {
    height: 32px;
    width: 85px;
    margin-right: 8px;
    padding: 4px;
    font-size: 10px;
  }
`
const EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 32px;
  color: ${Colors.gray500};
`

class CardsView extends Component {
  constructor(props) {
    super(props)
    const { student } = this.props
    this.state = {
      activeParentId: student.parents ? student.parents[0].userable_id : 0,
      openModal: false,
      card: {},
      parent: {},
      openConfirm: false,
      currentCardId: 0,
      auth: false,
      openActivate: false,
      currentCard: {},
      warningModal: false,
      width: window.innerWidth,
    }
  }

  componentDidMount = () => {
    const { activeParentId } = this.state
    const { country, student, getCards, anyLoading, loadingCards } = this.props

    if (country.payment_provider === 'Conekta') {
      if( student.center.id === 12){
        Conekta.setPublicKey(CONEKTA_PUBLIC_EAM_KEY)
      }else{
        Conekta.setPublicKey(CONEKTA_PUBLIC_ADV_KEY)
      }
    }
    //  else if (country.payment_provider === 'SrPago') {
    //   SrPago.setPublishableKey(SR_PAGO_PUBLIC_KEY)
    //   SrPago.setLiveMode(false)
    // }
    // else if(country.payment_provider === 'PayU'){
    //   payU.setPublicKey(PAYU_PUBLIC_KEY)
    // }

    if (!anyLoading && !loadingCards) {
      getCards(student.id, activeParentId)
    }
    window.addEventListener('resize', this.updateDimensions)
  }

  componentWillReceiveProps = (nextProps) => {
    const { cards } = nextProps
    if (cards.authorized && cards.unauthorized) {
      if (cards.authorized.length === 0 &&
          cards.unauthorized.length === 0) {
        this.setState({ warningModal: true })
      }
    }
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.updateDimensions)
  }

  onParentClick = id => () => {
    const { student, getCards } = this.props
    this.setState({ activeParentId: Number(id) })
  }

  updateDimensions = () => {
    const width = window.innerWidth
    this.setState({ width })
  }

  handleAuth = () => {
    const { student, authorizeCard } = this.props
    const { currentCardId } = this.state
    authorizeCard(student.id, currentCardId)
  }

  handleUnauth = () => {
    const { student, unauthorizeCard } = this.props
    const { currentCardId } = this.state
    unauthorizeCard(student.id, currentCardId)
  }

  handleDelete = () => {
    const { deleteCard } = this.props
    const { currentCardId } = this.state
    deleteCard(currentCardId)
  }

  handleActivate = () => {
    const { student, activateCard } = this.props
    const { currentCardId } = this.state
    activateCard(student.id, currentCardId)
  }

  sendCardInfo = (card_info) => {
    const { activeParentId } = this.state
    const { student, createCards, resetErrorCreate } = this.props
    resetErrorCreate()
    createCards(student.id, activeParentId, card_info)
  }

  openModal = (card = {}, parent) => {
    const { student } = this.props
    const { openModal, activeParentId } = this.state

    if (!student.parents) {
      return null
    }

    if (card.id && parent) {
      return this.setState({ openModal: true, card, parent })
    }

    const [parentActive] = student.parents.filter(p => p.userable_id === activeParentId)
    return this.setState({ openModal: true, card: {}, parent: {parent_id:parentActive.id,first_name:parentActive.first_name,last_name_paternal:parentActive.last_name_paternal,} })
  }

  closeModal = () => {
    this.props.resetErrorCreate()
    this.setState({ openModal: false })
  }

  openConfirmation = (cardId, auth) => {
    const { AuthCards, UnauthCards } = this.filterCards()
    const { notUnauthorizable, student } = this.props
    const { activeParentId } = this.state
    const currentCard = !auth
      ? AuthCards.find(card => card.id === cardId)
      : UnauthCards.find(card => card.id === cardId)
    const parent = student.parents.find(p => p.userable_id === activeParentId)
    if (!auth && currentCard.is_default) {
      notUnauthorizable(
        'No se puede desautorizar, active otra tarjeta antes de desautorizar esta tarjeta',
      )
    } else {
      this.setState({ openConfirm: true, currentCardId: cardId, auth, currentCard, parent })
    }
  }

  closeConfirmation = () => this.setState({ openConfirm: false })

  openActivate = (cardId, willDelete) => {
    const { cards, student } = this.props
    const { activeParentId } = this.state
    const currentCard = willDelete
      ? cards.unauthorized.find(card => card.id === cardId)
      : cards.authorized.find(card => card.id === cardId)
    const parent = student.parents.find(p => p.userable_id === activeParentId)
    this.setState({ openActivate: true, currentCardId: cardId, willDelete, currentCard, parent })
  }

  closeActivate = () => this.setState({ openActivate: false })

  filterCards = () => {
    const { student, cards, loadingCards } = this.props
    const { activeParentId } = this.state
    if (!cards.authorized) {
      return {}
    }
    const cardsToFilter = cards.authorized ? cards : student.credit_cards
    if (cardsToFilter.authorized) {
      const AuthCards = cards.authorized.filter(card => card && card.parent_id === activeParentId)
      const UnauthCards = cards.unauthorized.filter(
        card => card && card.parent_id === activeParentId,
      )
      return {
        AuthCards,
        UnauthCards,
      }
    }
    const AuthCards = cardsToFilter
      .filter(card => card && card.parent_id === activeParentId)
      .filter(card => card.authorized_at !== null)
    const UnauthCards = cardsToFilter
      .filter(card => card && card.parent_id === activeParentId)
      .filter(card => card.authorized_at === null)
    return {
      AuthCards,
      UnauthCards,
    }
  }

  renderAuthCards = () => {
    const { AuthCards } = this.filterCards()

    if (!AuthCards || AuthCards.length <= 0) {
      return null
    }

    return (
      <div>
        <Header>Tarjetas Autorizadas</Header>
        {AuthCards.map(card => (
          <CreditCard
            key={card.id}
            card={card}
            parent={parent}
            onEditCard={this.toggleModal}
            auth
            onUnauth={this.openConfirmation}
            onActivate={this.openActivate}
            openedByDefault={card.is_default}
          />
        ))}
      </div>
    )
  }

  renderUnauthCards = () => {
    const { UnauthCards } = this.filterCards()

    if (!UnauthCards || UnauthCards.length <= 0) {
      return null
    }

    return (
      <div>
        <Header>Tarjetas No Autorizadas</Header>
        {UnauthCards.map(card => (
          <CreditCard
            key={card.id}
            card={card}
            parent={parent}
            onEditCard={this.toggleModal}
            onAuth={this.openConfirmation}
            onDelete={this.openActivate}
            willDelete
          />
        ))}
      </div>
    )
  }

  renderContent = () => {
    const { cards } = this.props

    if (cards.authorized && cards.authorized.length === 0 &&
      cards.unauthorized && cards.unauthorized.length === 0) {
      return <EmptyState>No tiene tarjetas registradas</EmptyState>
    }

    return (
      <div>
        {this.renderAuthCards()}
        {this.renderUnauthCards()}
      </div>
    )
  }

  render() {
    const {
      student,
      relations,
      loadingCreate,
      loadingCards,
      errorAfterCreate,
      loadingAuth,
      loadingActivate,
      cards,
      country,
    } = this.props
    const {
      openModal,
      activeParentId,
      openConfirm,
      auth,
      openActivate,
      willDelete,
      currentCard,
      parent,
      width,
    } = this.state
    const activeParent = student.parents
      ? student.parents.find(p => p.userable_id === activeParentId)
      : undefined
    const activeRelation =
      activeParent && relations && relations.find(rel => rel.id === activeParent.relation_id)

    const propsToModal = {
      open: openModal,
      onClose: this.closeModal,
      parent,
      sendCard: this.sendCardInfo,
      loading: loadingCreate,
      errorAfterCreate,
      cards,
    }

    return (
      <PageContainer>
        <ParentContainer>
          <ParentListHeader>Seleccionar un Tutor:</ParentListHeader>
          <ParentList>
            {student.parents &&
              student.parents.map((parent) => {
                const relation = relations.find(rel => rel.id === parent.relation_id)

                if (parent.userable_id === activeParentId) {
                  return (
                    <ParentListItem
                      key={Math.random()}
                      active
                      id={parent.userable_id}
                      onClick={this.onParentClick(parent.userable_id)}
                    >
                      {relation
                        ? `${parent.first_name} ${parent.last_name_paternal} (${
                          relation.translations.es
                        })`
                        : `${parent.first_name} ${parent.last_name_paternal}`}
                    </ParentListItem>
                  )
                }
                return (
                  <ParentListItem
                    key={Math.random()}
                    id={parent.id}
                    onClick={this.onParentClick(parent.userable_id)}
                  >
                    {relation
                      ? `${parent.first_name} ${parent.last_name_paternal} (${
                        relation.translations.es
                      })`
                      : `${parent.first_name} ${parent.last_name_paternal}`}
                  </ParentListItem>
                )
              })}
          </ParentList>
        </ParentContainer>
        <CardListContainer>
          <ProfileHeader
            header={
              activeParent && activeRelation
                ? `Tarjetas de ${activeParent.first_name} (${activeRelation.translations.es})`
                : `Tarjeta de ${activeParent.first_name}`
            }
            submit
            buttons={[
              <Button ghost small key="button" onClick={this.openModal}>
                + Agregar Tarjeta
              </Button>,
            ]}
            noSave
          />
          <CardList>
            {loadingCards ?
              <LoadingSpinner containerHeight={120} size={25} /> :
              this.renderContent()}
          </CardList>
        </CardListContainer>
        {getModalToRender(country.payment_provider, propsToModal)}
        <AuthorizeModal
          card={currentCard}
          isBeingAuthorized={auth}
          isOpen={openConfirm}
          isSmallScreen={width < 763}
          loading={loadingAuth}
          onAuth={this.handleAuth}
          onClose={this.closeConfirmation}
          onUnauth={this.handleUnauth}
          parent={parent}
          student={student}
        />
        <ActivateCardModal
          card={currentCard}
          isOpen={openActivate}
          isSmallScreen={width < 763}
          loading={loadingActivate}
          onActivate={this.handleActivate}
          onClose={this.closeActivate}
          onDelete={this.handleDelete}
          parent={parent}
          student={student}
          willDelete={willDelete}
        />
        <Modal
          isOpened={this.state.warningModal}
          headerTitle="Aviso"
          full={width < 763}
          onClose={() => this.setState({ warningModal: false })}
        >
          <Warning>
            Favor de agregar una tarjeta para poder pagar
          </Warning>
        </Modal>
      </PageContainer>
    )
  }
}

const mapStateToProps = ({ cards, ...state }) => ({
  loadingStudent: state.classrooms.get.fetching,
  relations: state.relations.get.results,
  cards: cards.get.results,
  loadingCards: cards.get.fetching,
  loadingCreate: cards.create.fetching,
  errorAfterCreate: cards.create.error,
  loadingAuth: cards.auth.fetching,
  loadingActivate: cards.activate.fetching,
  country: Selectors.activeCountry(state),
})

const mapDispatchToProps = dispatch => ({
  getCards: student_id => dispatch(CardActions.getRequest({ student_id })),
  createCards: (student_id, parent_id, card_info) =>
    dispatch(CardActions.createCardRequest(student_id, parent_id, card_info)),
  resetErrorCreate: () => dispatch(CardActions.resetError()),
  authorizeCard: (student_id, card_id) =>
    dispatch(CardActions.authorizeRequest(student_id, card_id)),
  unauthorizeCard: (student_id, card_id) =>
    dispatch(CardActions.unauthorizeRequest(student_id, card_id)),
  activateCard: (student_id, card_id) => dispatch(CardActions.activateRequest(student_id, card_id)),
  notUnauthorizable: text => dispatch(notificationFail(text)),
  deleteCard: card_id => dispatch(CardActions.deleteRequest(card_id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CardsView)



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/CardsView.jsx